import styled from "styled-components";

const GlobalStyleWrapper = styled.div`
  .ant-form-item {
    margin-bottom: 15px;
  }
  .ant-form-item-label {
    padding-bottom: 0;
  }

  a {
    :hover {
      opacity: 0.6;
    }
  }

  .ant-input-affix-wrapper,input{
    padding: 14px 20px; 
  }

  .ant-btn,.ant-select{
    height:54px!important;
  }
`;

export default GlobalStyleWrapper;
